import {
  canManageGames,
  canManageGameSets,
  canManageUsers,
  canManageClasses,
  canManageAllGroups,
  isOwnerOrAdmin,
  isOwnerAdminOrProfessor,
  canGenerateReports,
  canOpenGameListAndGameEdit,
  canManageEnvironments
} from '../middleware/middleware';

import ChallengeEdit from '../../components/blade/pages/ChallengeEdit';
import ChallengesList from '../../components/blade/pages/ChallengesList';
import EventPoolEdit from '../../components/blade/pages/EventPoolEdit';
import EventPoolsList from '../../components/blade/pages/EventPoolsList';
import CharacterEdit from '../../components/blade/pages/CharacterEdit';
import CharactersList from '../../components/blade/pages/CharactersList';
import ClassEdit from '../../components/blade/pages/ClassEdit';
import ClassList from '../../components/blade/pages/ClassList';
import CouponEdit from '../../components/blade/pages/CouponEdit';
import CouponList from '../../components/blade/pages/CouponList';
import EnvironmentEdit from '../../components/blade/pages/EnvironmentEdit';
import EnvironmentList from '../../components/blade/pages/EnvironmentList';
import SignInEdit from '../../components/blade/pages/SignInEdit';
import SignInList from '../../components/blade/pages/SignInList';
import RegistrationLinkEdit from '../../components/blade/pages/RegistrationLinkEdit';
import RegistrationLinkList from '../../components/blade/pages/RegistrationLinkList';
import GameEdit from '../../components/blade/pages/GameEdit';
import GamesList from '../../components/blade/pages/GamesList';
import GameSetEdit from '../../components/blade/pages/GameSetEdit';
import GamesSetList from '../../components/blade/pages/GameSetList';
import CharacterTreeEdit from '../../components/blade/pages/CharacterTreeEdit';
import CharacterTreeList from '../../components/blade/pages/CharacterTreeList';
import GroupEdit from '../../components/blade/pages/GroupEdit';
import GroupsList from '../../components/blade/pages/GroupsList';
import MetricEdit from '../../components/blade/pages/MetricEdit';
import MetricsList from '../../components/blade/pages/MetricsList';
import OutroEdit from '../../components/blade/pages/OutroEdit';
import OutrosList from '../../components/blade/pages/OutrosList';
import IndividualDecisionEdit from '../../components/blade/pages/IndividualDecisionEdit';
import IndividualDecisionsList from '../../components/blade/pages/IndividualDecisionsList';
import RoleEdit from '../../components/blade/pages/RoleEdit';
import RolesList from '../../components/blade/pages/RolesList';
import TeamDecisionEdit from '../../components/blade/pages/TeamDecisionEdit';
import TeamDecisionsList from '../../components/blade/pages/TeamDecisionsList';
import UserChangePassword from '../../components/blade/pages/UserChangePassword';
import UserEdit from '../../components/blade/pages/UserEdit';
import UsersList from '../../components/blade/pages/UsersList';
import ArticleEdit from '../../components/blade/pages/ArticleEdit';
import ArticlesList from '../../components/blade/pages/ArticlesList';
import ArticleCategoryEdit from '../../components/blade/pages/ArticleCategoryEdit';
import ArticleCategoriesList from '../../components/blade/pages/ArticleCategoriesList';
import UsageDataRequest from '../../components/blade/pages/UsageDataRequest';
import ReasonDataRequest from '../../components/blade/pages/ReasonDataRequest';
import DataTableView from '../../components/blade/pages/DataTableView';

export default [
  { path: '/blade/challenges', component: ChallengesList, beforeEnter: canManageGames },
  { path: '/blade/challenges/create', component: ChallengeEdit, beforeEnter: canManageGames },
  { path: '/blade/challenges/:challengeId/edit', component: ChallengeEdit, beforeEnter: canManageGames },
  { path: '/blade/event-pools', component: EventPoolsList, beforeEnter: canManageGames },
  { path: '/blade/event-pools/create', component: EventPoolEdit, beforeEnter: canManageGames },
  { path: '/blade/event-pools/:eventPoolId/edit', component: EventPoolEdit, beforeEnter: canManageGames },
  { path: '/blade/characters', component: CharactersList, beforeEnter: canManageGames },
  { path: '/blade/characters/create', component: CharacterEdit, beforeEnter: canManageGames },
  { path: '/blade/characters/:characterId/edit', component: CharacterEdit, beforeEnter: canManageGames },
  { path: '/blade/coupons', component: CouponList, beforeEnter: isOwnerOrAdmin },
  { path: '/blade/coupons/create', component: CouponEdit, beforeEnter: isOwnerOrAdmin },
  { path: '/blade/coupons/:couponId/edit', component: CouponEdit, beforeEnter: isOwnerOrAdmin },
  { path: '/blade/classes', component: ClassList, beforeEnter: canManageClasses },
  { path: '/blade/classes/create', component: ClassEdit, beforeEnter: canManageClasses },
  { path: '/blade/classes/:classId/edit', component: ClassEdit, beforeEnter: canManageClasses },
  { path: '/blade/domainbrandings', component: SignInList, beforeEnter: canManageUsers },
  { path: '/blade/domainbrandings/create', component: SignInEdit, beforeEnter: canManageUsers },
  { path: '/blade/domainbrandings/:signinConfigId/edit', component: SignInEdit, beforeEnter: canManageUsers },
  { path: '/blade/registration-links', component: RegistrationLinkList, beforeEnter: canManageUsers },
  { path: '/blade/registration-links/create', component: RegistrationLinkEdit, beforeEnter: canManageUsers },
  { path: '/blade/registration-links/:registrationLinkId/edit', component: RegistrationLinkEdit, beforeEnter: canManageUsers },
  { path: '/blade/environments', component: EnvironmentList, beforeEnter: canManageEnvironments },
  { path: '/blade/environments/create', component: EnvironmentEdit, beforeEnter: canManageEnvironments },
  { path: '/blade/environments/:environmentId/edit', component: EnvironmentEdit, beforeEnter: canManageEnvironments },
  { path: '/blade/games', component: GamesList, beforeEnter: canOpenGameListAndGameEdit },
  { path: '/blade/games/create', component: GameEdit, beforeEnter: canManageGames },
  { path: '/blade/games/:gameId/edit', component: GameEdit, beforeEnter: canOpenGameListAndGameEdit },
  { path: '/blade/gamesets', component: GamesSetList, beforeEnter: canManageGameSets },
  { path: '/blade/gamesets/create', component: GameSetEdit, beforeEnter: canManageGameSets },
  { path: '/blade/gamesets/:gameSetId/edit', component: GameSetEdit, beforeEnter: canManageGameSets },
  { path: '/blade/character-tree', component: CharacterTreeList, beforeEnter: canManageGames },
  { path: '/blade/character-tree/create', component: CharacterTreeEdit, beforeEnter: canManageGames },
  { path: '/blade/character-tree/:characterTreeNodeId/edit', component: CharacterTreeEdit, beforeEnter: canManageGames },
  { path: '/blade/playthroughs', component: GroupsList, beforeEnter: canManageAllGroups },
  { path: '/blade/playthroughs/create', component: GroupEdit, beforeEnter: canManageAllGroups },
  { path: '/blade/playthroughs/:groupId/edit', component: GroupEdit, beforeEnter: canManageAllGroups },
  { path: '/blade/minor-decisions', component: IndividualDecisionsList, beforeEnter: canManageGames },
  { path: '/blade/minor-decisions/create', component: IndividualDecisionEdit, beforeEnter: canManageGames },
  { path: '/blade/minor-decisions/:individualDecisionId/edit', component: IndividualDecisionEdit, beforeEnter: canManageGames },
  { path: '/blade/metrics', component: MetricsList, beforeEnter: canManageGames },
  { path: '/blade/metrics/create', component: MetricEdit, beforeEnter: canManageGames },
  { path: '/blade/metrics/:metricId/edit', component: MetricEdit, beforeEnter: canManageGames },
  { path: '/blade/outros', component: OutrosList, beforeEnter: canManageGames },
  { path: '/blade/outros/create', component: OutroEdit, beforeEnter: canManageGames },
  { path: '/blade/outros/:outroId/edit', component: OutroEdit, beforeEnter: canManageGames },
  { path: '/blade/roles', component: RolesList, beforeEnter: canManageGames },
  { path: '/blade/roles/create', component: RoleEdit, beforeEnter: canManageGames },
  { path: '/blade/roles/:roleId/edit', component: RoleEdit, beforeEnter: canManageGames },
  { path: '/blade/major-decisions', component: TeamDecisionsList, beforeEnter: canManageGames },
  { path: '/blade/major-decisions/create', component: TeamDecisionEdit, beforeEnter: canManageGames },
  { path: '/blade/major-decisions/:teamDecisionId/edit', component: TeamDecisionEdit, beforeEnter: canManageGames },
  { path: '/blade/users', component: UsersList, beforeEnter: canManageUsers },
  { path: '/blade/users/create', component: UserEdit, beforeEnter: canManageUsers },
  { path: '/blade/users/:userId/edit', component: UserEdit, beforeEnter: canManageUsers },
  { path: '/blade/users/:userId/password', component: UserChangePassword, beforeEnter: canManageUsers },
  { path: '/blade/articles', component: ArticlesList, beforeEnter: canManageUsers },
  { path: '/blade/articles/create', component: ArticleEdit, beforeEnter: canManageUsers },
  { path: '/blade/articles/:articleId/edit', component: ArticleEdit, beforeEnter: canManageUsers },
  { path: '/blade/article-categories', component: ArticleCategoriesList, beforeEnter: canManageUsers },
  { path: '/blade/article-categories/create', component: ArticleCategoryEdit, beforeEnter: canManageUsers },
  { path: '/blade/article-categories/:articleCategoryId/edit', component: ArticleCategoryEdit, beforeEnter: canManageUsers },
  { path: '/blade/usageData', component: UsageDataRequest, beforeEnter: canGenerateReports },
  { path: '/blade/reasonData', component: ReasonDataRequest, beforeEnter: canGenerateReports },
  { path: '/blade/dataTable', component: DataTableView, beforeEnter: isOwnerAdminOrProfessor }
];



// WEBPACK FOOTER //
// ./src/router/blade/routes.js